/**
 * One accent hue per sport (HSL degrees), so a sport keeps its colour wherever it shows up: the tiles, the glow on a selected one,
 * and the sport pages. Lime (the brand) stays the colour of actions; these only tint the sport itself.
 */
export const SPORT_HUE = {
  badminton: 84,
  tennis: 48,
  table_tennis: 199,
  pickleball: 168,
  squash: 285,
  basketball: 24,
  cricket: 350,
  gym: 174,
  lifting: 262,
  football: 140,
  swimming: 212,
  physiotherapy: 174,
  weight_lifting: 262,
};

export const hueOf = (sport) => SPORT_HUE[String(sport || "").replace(/-/g, "_")] ?? 84;

/** Colours for a hue as CSS strings: `soft` a faint wash, `ring` the edge, `text` readable on dark, `glow` the halo. */
export const sportColors = (hue) => ({
  soft: `hsl(${hue} 85% 55% / 0.14)`,
  tint: `linear-gradient(160deg, hsl(${hue} 85% 55% / 0.24), hsl(${hue} 85% 55% / 0.04) 70%)`,
  ring: `hsl(${hue} 90% 62%)`,
  text: `hsl(${hue} 95% 72%)`,
  glow: `0 8px 22px hsl(${hue} 85% 55% / 0.22)`,
});
